import logo from "./logo.svg";
import { HashRouter, Routes, Route } from "react-router-dom";
import Main from "./pages/main";
import MentionLegal from "./pages/mentionLegal";
import Politique from "./pages/politique";
import "./assets/css/setup.css";
import "./assets/css/style.css";
// import "./assets/css/responsive.css";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/mentions-legal" element={<MentionLegal />} />
        <Route path="/politique-de-confidentialite" element={<Politique />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
